<template>
  <i :class="classes">{{ text }}</i>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    classes() {
      return this.icon.startsWith('icon-') ? ['icon', this.icon] : ['material-icons'];
    },
    text() {
      return this.icon.startsWith('icon-') ? '' : this.icon;
    }
  },
};
</script>
